/**
 * Apple Pay (Payfort native session + HyperPay COPYandPAY) requires a secure context (HTTPS).
 * On plain HTTP (e.g. LAN IP dev), OPPWA checkAvailability throws InvalidAccessError.
 */
export function isApplePaySecureContext(): boolean {
  return typeof window !== "undefined" && window.isSecureContext === true;
}

export function canUseApplePayInBrowser(): boolean {
  if (!isApplePaySecureContext()) return false;
  try {
    const APS = (window as { ApplePaySession?: { canMakePayments?: () => boolean } }).ApplePaySession;
    if (!APS || typeof APS.canMakePayments !== "function") return false;
    return !!APS.canMakePayments();
  } catch {
    return false;
  }
}

export function stripApplePayFromBrands(brands: string): string {
  return brands
    .split(/\s+/)
    .filter((token) => token && token !== "APPLEPAY")
    .join(" ")
    .trim();
}

export function sanitizeHyperPayWpwlOptions(
  wpwlOptions?: Record<string, unknown> | null
): Record<string, unknown> | undefined {
  if (!wpwlOptions) return undefined;
  if (canUseApplePayInBrowser()) return wpwlOptions;
  const next = { ...wpwlOptions };
  delete next.applePay;
  return next;
}
